window.rotationFilter = (function($) {

  /*
  public
  */

  // Initialize Rotations
  var init = function() {
    initFilter();
  };

  /*
  private
  */

  /* Set up rotation filtering for department calendar, user calendar, and rotations
     @note: Filtering uses the OR operation on search terms
            Filtering is done against the comma-delimited value of a select2 dropdown
  */
  var initFilter = function() {
    $('#remove-rotation-filter').on('click', function() {
      $('#rotation-filter').val('').keyup();
    }).hide();

    $('#rotation-filter').on('keyup', function() {
      var $rotations = $('#rotations div, #rotation_tab li.ui-draggable, #rotation-shift-types li.ui-draggable');
      var $keywords = $(this).val().toLowerCase();
      $rotations.show().filter(function() {
        var rotationKeyword = $(this).data('keyword').toString().toLowerCase();
        return (rotationKeyword.indexOf($keywords) < 0);
      }).hide();
      if ($(this).val()) {
        $('#remove-rotation-filter').show();
      } else {
        $('#remove-rotation-filter').hide();
      }
    });
  };

  return {
    init: init,
  };

})(jQuery);
